export const companyType = [
  {
    label: 'Selecione'
  },
  {
    label: 'Fornecedor',
  },
  {
    label: 'Varejista'
  }
]